import React, { FC } from "react";

import { useTranslation } from "react-i18next";

import { StepComponentProps } from "@/components/organisms";
import { StyledHeaderTitleBase } from "@/styles/components";

import { StepId } from "../../constants";
import { AddressCard, ContactCard, FinancialCard, GeneralCard } from "./cards";

const SummaryStep: FC<StepComponentProps> = ({ changeActiveStep }) => {
    const { t } = useTranslation();

    return (
        <>
            <StyledHeaderTitleBase>{t("Common.Summary")}</StyledHeaderTitleBase>
            <GeneralCard onEdit={() => changeActiveStep(StepId.General)} />
            <AddressCard onEdit={() => changeActiveStep(StepId.Address)} />
            <ContactCard onEdit={() => changeActiveStep(StepId.Contact)} />
            <FinancialCard onEdit={() => changeActiveStep(StepId.FinancialTax)} />
        </>
    );
};

export default SummaryStep;
